{
  "GENERAL_SETTINGS": {
    "TITLE": "Configuración de la cuenta",
    "SUBMIT": "Actualizar ajustes",
    "BACK": "Atrás",
    "DISMISS": "Descartar",
    "UPDATE": {
      "ERROR": "No se pudo actualizar la configuración, ¡inténtalo de nuevo!",
      "SUCCESS": "Configuración de cuenta actualizada correctamente"
    },
    "FORM": {
      "ERROR": "Por favor, corrija los errores de formulario",
      "GENERAL_SECTION": {
        "TITLE": "Ajustes generales",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID de Cuenta",
        "NOTE": "Este ID es necesario si estás construyendo una integración basada en API"
      },
      "NAME": {
        "LABEL": "Nombre de cuenta",
        "PLACEHOLDER": "Tu nombre de cuenta",
        "ERROR": "Por favor, introduzca un nombre de cuenta válido"
      },
      "LANGUAGE": {
        "LABEL": "Idioma del sitio",
        "PLACEHOLDER": "Tu nombre de cuenta",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Dominio",
        "PLACEHOLDER": "El dominio donde recibirá los emails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Email de soporte",
        "PLACEHOLDER": "Email de soporte de su empresa",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Número de días después de que un ticket se resuelva automáticamente si no hay actividad",
        "PLACEHOLDER": "30",
        "ERROR": "Por favor introduzca una duración válida de resolución automática (mínimo 1 día y máximo 999 días)",
        "NOTE": "Número de horas de inactividad tras las cuales cualquier conversación abierta se resolverá automáticamente."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Continuidad de la conversación con emails está habilitada para su cuenta.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Ahora puede recibir emails en su dominio personalizado."
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Número de días tras los cuales una conversación vacía debe resolverse automáticamente si no hay actividad",
        "PLACEHOLDER": "nunca",
        "ERROR": "Por favor, introduce una duración válida de resolución automática para conversaciones vacías (mínimo 1 día y máximo 999 días)"
      },
      "PHONE": {
        "TITLE": "Configuración del PBX",
        "NOTE": "Configura la conexión a tu PBX para llamadas telefónicas",
        "SIP_HOST": {
          "LABEL": "Dominio SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Modo de marcación",
          "MODES": {
            "direct": "Directa - la llamada se marca inmediatamente al hacer clic en el enlace telefónico",
            "indirect": "Indirecta - el número de teléfono se prepara en el cuadro de entrada del widget telefónico"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Acceso a grabación de llamadas",
          "MODES": {
            "admin_only": "Solo administradores",
            "admin_and_assigned_agent": "Administradores y agente asignado",
            "inbox_members": "Todos los agentes con acceso a la bandeja de entrada"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Configuración de correo electrónico",
        "NOTE": "Modifica el comportamiento de las bandejas de entrada de correo"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Modo de visualización de la marca de tiempo de la conversación",
        "MODES": {
          "both": "Creada y última actividad",
          "last_activity_only": "Solo última actividad",
          "last_customer_message": "Último mensaje del cliente"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Bloquear dominios con baja reputación"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Incluir mensaje original en la respuesta al correo"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Resolver automáticamente una nueva conversación"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Mover automáticamente una nueva conversación de correo a la bandeja del robot que procesó los pedidos del contacto"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Etiquetas extendidas - Permitir nombres de etiquetas más largos con interfaz emergente más grande"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Asignar automáticamente la conversación al agente que envió la última respuesta"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Modo de notificaciones push",
        "MODES": {
          "all_inboxes": "Todas las bandejas - Enviar notificaciones para todos los tipos de canales",
          "chat_only": "Solo chat - Enviar notificaciones solo para canales que no sean correo"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Permitir alternar la firma en los mensajes enviados"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Mostrar el estado de chat del agente en el wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Mostrar los nombres completos de los adjuntos sin truncar"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Inicio de sesión con contraseña",
        "MODES": {
          "allowed_for_all": "Permitido para todos los usuarios",
          "allowed_for_agents_only": "Permitido solo para agentes (los administradores deben usar OAuth)",
          "password_login_disabled": "Deshabilitado - Solo OAuth"
        }
      }
    },
    "LEARN_MORE": "Más información",
    "PAYMENT_PENDING": "Tu pago está pendiente. Por favor actualiza tu información de pago para seguir usando este software",
    "LIMITS_UPGRADE": "Su cuenta ha excedido los límites de uso, por favor actualice su plan para seguir usando este software",
    "OPEN_BILLING": "Abrir facturación",
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Has superado el límite de conversaciones. El plan Hacker permite solo 500 conversaciones.",
      "INBOXES": "Has superado el límite de bandejas de entrada. El plan Hacker solo admite chat en vivo del sitio web. Las bandejas de entrada adicionales como correo electrónico, WhatsApp, etc. requieren un plan de pago.",
      "AGENTS": "Has superado el límite de agentes. El plan Hacker permite solo 2 agentes.",
      "NON_ADMIN": "Por favor, contacta a tu administrador para actualizar el plan y continuar usando todas las funciones."
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Eliminar tu cuenta",
      "NOTE": "Una vez que elimines tu cuenta, todos tus datos serán eliminados.",
      "BUTTON_TEXT": "Eliminar tu cuenta",
      "CONFIRM": {
        "TITLE": "Eliminar cuenta",
        "MESSAGE": "Eliminar tu cuenta es irreversible. Introduce el nombre de tu cuenta a continuación para confirmar que deseas eliminarla permanentemente.",
        "BUTTON_TEXT": "Eliminar",
        "DISMISS": "Cancelar",
        "PLACE_HOLDER": "Por favor, escribe {accountName} para confirmar"
      },
      "SUCCESS": "Cuenta marcada para eliminación",
      "FAILURE": "No se pudo eliminar la cuenta, ¡inténtalo de nuevo!",
      "SCHEDULED_DELETION": {
        "TITLE": "Cuenta programada para eliminación",
        "MESSAGE_MANUAL": "Esta cuenta está programada para eliminación el {deletionDate}. Esto fue solicitado por un administrador. Puedes cancelar la eliminación antes de esta fecha.",
        "MESSAGE_INACTIVITY": "Esta cuenta está programada para eliminación el {deletionDate} debido a inactividad de la cuenta. Puedes cancelar la eliminación antes de esta fecha.",
        "CLEAR_BUTTON": "Cancelar eliminación programada"
      }
    },
    "NEW_VERSION_AVAILABLE": "Hay una nueva versión disponible. Recarga para obtener las últimas actualizaciones.",
    "RELOAD_NOW": "Actualizar ahora"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Pulse Enter para seleccionar",
      "ENTER_TO_REMOVE": "Presione Enter para eliminar",
      "NO_OPTIONS": "La lista está vacía",
      "NO_RESULT": "No se encontraron resultados",
      "SELECT_ONE": "Seleccione uno",
      "SELECT": "Seleccionar"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notificaciones",
    "MARK_ALL_DONE": "Marcar Todo Hecho",
    "DELETE_TITLE": "Eliminado",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Notificaciones sin leer",
      "ALL_NOTIFICATIONS": "Ver todas las notificaciones",
      "LOADING_UNREAD_MESSAGE": "Cargando notificaciones no leídas...",
      "EMPTY_MESSAGE": "No tiene notificaciones sin leer"
    },
    "LIST": {
      "404": "Aún no hay notificaciones",
      "LOADING_MESSAGE": "Cargando notificaciones...",
      "TABLE_HEADER": [
        "Nombre",
        "Número telefónico",
        "Conversaciones",
        "Último Contactado"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nueva conversación",
      "conversation_assignment": "Conversación asignada",
      "assigned_conversation_new_message": "Nuevo mensaje",
      "participating_conversation_new_message": "Nuevo mensaje",
      "conversation_mention": "Mención",
      "sla_missed_first_response": "SLA perdido",
      "sla_missed_next_response": "SLA perdido",
      "sla_missed_resolution": "SLA perdido"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Desconectado",
      "RECONNECTING": "Reconectando...",
      "RECONNECT_SUCCESS": "Reconectado"
    },
    "BUTTON": {
      "REFRESH": "Actualizar"
    },
    "CONNECTION_LOST": {
      "TITLE": "Conexión perdida",
      "DESCRIPTION": "No pudimos conectar con el servidor. Comprueba tu conexión e inténtalo de nuevo.",
      "RETRY": "Intentar de nuevo"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Buscar o saltar a",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Informes",
      "CONVERSATION": "Conversación",
      "BULK_ACTIONS": "Acciones masivas",
      "CHANGE_ASSIGNEE": "Cambiar Asignado",
      "CHANGE_PRIORITY": "Cambiar prioridad",
      "CHANGE_TEAM": "Cambiar equipo",
      "SNOOZE_CONVERSATION": "Posponer conversación",
      "EXECUTE_MACRO": "Ejecutar macro",
      "ADD_LABEL": "Añadir etiqueta a la conversación",
      "REMOVE_LABEL": "Eliminar etiqueta de la conversación",
      "SETTINGS": "Ajustes",
      "AI_ASSIST": "Asistencia AI",
      "APPEARANCE": "Apariencia",
      "SNOOZE_NOTIFICATION": "Posponer notificación"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Ir al panel de conversaciones",
      "GO_TO_CONTACTS_DASHBOARD": "Ir al panel de contactos",
      "GO_TO_REPORTS_OVERVIEW": "Ir al Resumen de Reportes",
      "GO_TO_CONVERSATION_REPORTS": "Ir a Reportes de Conversación",
      "GO_TO_AGENT_REPORTS": "Ir a Reportes de Agente",
      "GO_TO_LABEL_REPORTS": "Ir a Reportes de Etiquetas",
      "GO_TO_INBOX_REPORTS": "Ir a Reportes de Entrada",
      "GO_TO_TEAM_REPORTS": "Ir a Reportes de Equipo",
      "GO_TO_SETTINGS_AGENTS": "Ir a la configuración del agente",
      "GO_TO_SETTINGS_TEAMS": "Ir a Configuración de Equipo",
      "GO_TO_SETTINGS_INBOXES": "Ir a Ajustes de la Bandeja de Entrada",
      "GO_TO_SETTINGS_LABELS": "Ir a Configuración de Etiqueta",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Ir a Configuración de Respuesta Predefinida",
      "GO_TO_SETTINGS_APPLICATIONS": "Ir a la configuración de la aplicación",
      "GO_TO_SETTINGS_ACCOUNT": "Ir a Configuración de Cuenta",
      "GO_TO_SETTINGS_PROFILE": "Ir a Configuración del Perfil",
      "GO_TO_NOTIFICATIONS": "Ir a Notificaciones",
      "ADD_LABELS_TO_CONVERSATION": "Añadir etiqueta a la conversación",
      "ASSIGN_AN_AGENT": "Asignar un agente",
      "AI_ASSIST": "Asistencia IA",
      "ASSIGN_PRIORITY": "Asignar prioridad",
      "ASSIGN_A_TEAM": "Asignar un equipo",
      "EXECUTE_A_MACRO": "Ejecutar una macro",
      "MUTE_CONVERSATION": "Silenciar conversación",
      "UNMUTE_CONVERSATION": "Quitar silencio de conversación",
      "REMOVE_LABEL_FROM_CONVERSATION": "Eliminar etiqueta de la conversación",
      "REOPEN_CONVERSATION": "Resolver conversación",
      "RESOLVE_CONVERSATION": "Resolver conversación",
      "SEND_TRANSCRIPT": "Enviar una transcripción por email",
      "SNOOZE_CONVERSATION": "Posponer conversación",
      "UNTIL_NEXT_REPLY": "Hasta la siguiente respuesta",
      "UNTIL_NEXT_WEEK": "Hasta la próxima semana",
      "UNTIL_TOMORROW": "Hasta mañana",
      "UNTIL_NEXT_MONTH": "Hasta el mes próximo",
      "AN_HOUR_FROM_NOW": "Hasta una hora a partir de ahora",
      "UNTIL_CUSTOM_TIME": "Personalizar...",
      "CHANGE_APPEARANCE": "Cambiar apariencia",
      "LIGHT_MODE": "Claro",
      "DARK_MODE": "Oscuro",
      "SYSTEM_MODE": "Sistema",
      "SNOOZE_NOTIFICATION": "Posponer notificación"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Cargando aplicación del tablero..."
  },
  "COMMON": {
    "OR": "O",
    "CLICK_HERE": "haz clic aquí"
  }
}
